import { communityConfigService } from '@/services/community-config.service'
import { getTenantFromHost } from '@/utils/tenant.utils'

/**
 * Resolve the eztech community ID for the current tenant host (non-FSDS only).
 */
export async function resolveCommunityIdFromHost(hostname?: string): Promise<string | null> {
  if (typeof window === 'undefined' && !hostname) {
    return null
  }

  const host = hostname ?? window.location.hostname
  const tenantId = getTenantFromHost(host)

  try {
    const config = await communityConfigService.getBySubdomain(tenantId)
    if (config?.id) {
      return config.id
    }
  } catch {
    // fall through to domain lookup
  }

  try {
    const config = await communityConfigService.getByDomain(host)
    if (config?.id) {
      return config.id
    }
  } catch {
    // no community found
  }

  return null
}
